import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref } from "vue";
import { queryCustomFormTable, deleteCustomFormById } from "@/api/customForm";
import { useRouter } from "vue-router";

export default function useCustomFormTable() {
  const router = useRouter();
  // 所搜条件ref
  const searchRef = ref(null);

  // 编制弹窗ref
  const adjustRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    formKey: null,
    formName: null,
    formType: null,
    state: null,
  });

  // 分页条件
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 表格遮罩
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 表格列配置
  const columns = ref([
    {
      label: "表单key",
      prop: "formKey",
    },
    {
      label: "表单名",
      prop: "formName",
    },
    {
      label: "表单类型",
      prop: "formType",
    },
    {
      label: "备注",
      prop: "remark",
    },
    {
      label: "状态",
      prop: "state",
    },
    {
      label: "表单地址",
      prop: "formUrl",
    },
    {
      label: "所属系统",
      prop: "serviceCodeText",
    },
  ]);

  // 获取数据
  const queryTable = () => {
    tableLoading.value = true;
    queryCustomFormTable({
      ...searchData,
      page: pages.page,
    })
      .then((res) => {
        tableData.value = res.data.records || [];
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置按钮
  const handleReset = () => {
    searchRef.value?.resetFields();
    queryTable();
  };

  // 新增或编辑按钮
  const handleAdjust = (row, type) => {
    adjustRef.value?.handleDialogOpen({ row, type });
  };

  // 删除按钮
  const handleDelete = (row) => {
    ElMessageBox.confirm(`确定删除表单【${row.formName}】吗？`, "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteCustomFormById(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            queryTable();
          }
        });
      })
      .catch(() => { });
  };

  // 设计或预览
  const handleDesign = (row, type) => {
    router.push({
      path: "/portal/framework/generator",
      query: { config: JSON.stringify({ id: row.id, type }) },
    });
  };
  return {
    searchRef,
    adjustRef,
    searchData,
    pages,
    tableLoading,
    tableData,
    columns,
    queryTable,
    handleReset,
    handleAdjust,
    handleDelete,
    handleDesign,
  };
}
